<template>
    <section>
        <div class="pda-default" dir="">
            <div class="t-subtitle2">
                {{$t('468')}}
                <!-- 결제 수단 -->
            </div>

            <div class="mgt-4 t-body1 ">
                <div v-for="(method, index) in paymentMethodList" :key="index" >
                    <!-- {{method.moduleName}} -->

                    <div class="payment-method-item d-flex justify-content-center align-items-center mgt-12" 
                        
                        :class="{on: paymentMethod === method.moduleName}" 
                        @click="setPaymentMethod(method.moduleName)" 
                        
                        v-if="method.moduleName === 'bank_transfer' || method.moduleName === 'paypal'  || method.moduleName === 'dummy'"
                        
                        >
                            <div class="flex-1 mgl-16 mgr-16" v-if="method.moduleName === 'paypal'">
                                {{$t('470')}}
                                <!-- : {{method.moduleName}} -->
                            </div>
                            <div class="flex-1 mgl-16 mgr-16" v-else-if="method.moduleName === 'bank_transfer'">
                                {{$t('471')}}
                                <!-- : {{method.moduleName}} -->
                            </div>
                            <div class="flex-1 mgl-16 mgr-16" v-else-if="method.moduleName === 'dummy'">
                                {{method.moduleName}}
                            </div>
                            <div class="mgl-16 mgr-16" v-if="paymentMethod === method.moduleName">
                                <img src="@/assets/con_complete.svg" alt="">
                            </div>
                        <!-- <div v-if="method.moduleName === 'bank_transfer' || method.moduleName === 'paypal'  || method.moduleName === 'dummy'">

                        </div> -->

                    </div>
                </div>

                
            </div>

            
            <div v-if="paymentMethod">
                <hr class="divider mgt-16">
                <div v-if="paymentMethod === 'bank_transfer'">
                    <div class="t-body3 mgt-16">
                        {{$t('518')}}
                        <!-- 입금자 정보 -->
                    </div>
                    <div class="mgt-16">
                        <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                            id="depositorNameEl"
                        >
                            <i class="material-icons mdc-text-field__icon">
                            </i>
                            <input type="text" class="mdc-text-field__input"
                                maxlength="50" 
                                autocomplete="off"
                                v-model="depositorName"
                                id="depositorName"
                                v-validate="'required'"
                                
                            >
                            <div class="mdc-notched-outline">
                                <div class="mdc-notched-outline__leading"></div>
                                <div class="mdc-notched-outline__notch">
                                    <label for="tf-outlined" class="mdc-floating-label">
                                        {{$t('519')}}
                                        <!-- 입금자 이름 -->
                                    </label>
                                </div>
                                <div class="mdc-notched-outline__trailing"></div>
                            </div>
                        </div>
                        <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23 t-color-blue2">
                            <span>
                                {{$t('520')}}
                                <!-- 입금자가 다른 경우 수정할 수 있습니다. -->
                            </span>
                        </div>

                    </div>
                </div>


                <div v-if="paymentMethod === 'paypal'">
                    <div class="t-body3 mgt-16 t-color-gray2">
                        {{$t('472')}}
                        <!-- 카드 선택 -->
                    </div>
                    <div class="mgt-16">
                        <div class="first-item">
                            <div class="mdc-form-field">
                                <div class="mdc-radio radio-red">
                                    <input class="mdc-radio__native-control" type="radio" 
                                        v-model="creditcardId"
                                        id="creditcard"
                                        value="account"
                                        name="creditcard"
                                    >
                                    <div class="mdc-radio__background">
                                        <div class="mdc-radio__outer-circle"></div>
                                        <div class="mdc-radio__inner-circle"></div>
                                    </div>
                                </div>
                                <label for="creditcard">
                                    {{$t('469')}}
                                    <!-- PayPal 계정으로 결제 -->
                                </label>
                            </div>
                        </div>

                        <div class="mgt-16 d-flex justify-content-between align-items-center" v-for="(creditcard, index) in creditcardList" :key="index">
                            <div class="mdc-form-field">
                                <div class="mdc-radio radio-red">
                                    <input class="mdc-radio__native-control" type="radio" 
                                        v-model="creditcardId"
                                        :value="creditcard.id"
                                        name="creditcard"
                                        :id="`creditcard${creditcard.id}`"
                                    >
                                    <div class="mdc-radio__background">
                                        <div class="mdc-radio__outer-circle"></div>
                                        <div class="mdc-radio__inner-circle"></div>
                                    </div>
                                </div>
                                <label :for="`creditcard${creditcard.id}`">{{creditcard.cardNumber}}</label>
                            </div>
                            <div>
                                 <button class="mdc-button btn-white" @click="deleteCreditCard(creditcard.id)">
                                    {{$t('882')}}
                                    <!-- 삭제 -->
                                </button>
                            </div>
                        </div>
                        
                        <div class="mgt-16 t-body1 d-flex align-items-center" @click="toggleAddCardForm()">
                            <div class="w-40 t-center t-color-gray6 align-self-center t-line-h-0">
                                <i class="material-icons">add_circle_outline</i>
                            </div>
                            <div class="mgr-20 mgl-20 align-self-center">
                                {{$t('473')}}
                                <!-- 새 카드 추가 -->
                            </div>
                        </div>
                        <add-credit-card v-if="isAddCardForm" @toggleAddCardForm="toggleAddCardForm" @fatchCreditCard="fatchCreditCard"/>
                    </div>
                </div>
                
            </div>
            
        </div>

        <hr class="divider">
        
        <div class="bg-gray pda-default" v-if="orderData">
            <div class="t-subtitle2">
                {{$t('474')}}
                <!-- 결제 금액 -->
            </div>

            <div>
                <div class="d-flex justify-content-between align-items-center mgt-29">
                    <div class="t-body3 t-color-content1">
                        {{$t('475')}}
                        <!-- 강의 금액 -->
                    </div>
                    <div class="t-subtitle3">
                        <!-- KRW 22,000 -->
                        <span class="currency t-caption">{{orderData.currency}}</span>
                        {{$n(orderData.totalPrice)}} 
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mgt-29">
                    <div class="t-body3 t-color-content1">
                        {{$t('477')}}
                        <!-- 할인 금액 -->
                    </div>
                    <div class="t-subtitle3">
                        <!-- KRW 22,000 -->
                        <span class="currency t-caption">{{orderData.currency}}</span>
                        {{$n(orderData.discountPrice)}} 
                    </div>
                </div>
                
                <hr class="divider dashed mgt-29">

                <div class="d-flex justify-content-between align-items-center mgt-29">
                    <div class="t-body3 t-color-content1">
                        {{$t('481')}}
                        <!-- 총 결제  금액 -->
                    </div>
                    <div class="t-headline5">
                        <!-- KRW 22,000 -->
                        <span class="currency t-body3">{{orderData.currency}}</span>
                        {{$n(orderData.paymentPrice)}} 
                    </div>
                </div>

            </div>
            <div class="mgt-41 ">
                <div class="mdc-form-field d-flex justify-content-between align-items-center">
                    <div class="mdc-checkbox">
                        <input type="checkbox"
                            class="mdc-checkbox__native-control"
                            id="informationConsent"
                            v-model="informationConsent"
                        />
                        <div class="mdc-checkbox__background check-red">
                        <svg class="mdc-checkbox__checkmark"
                            viewBox="0 0 24 24">
                            <path class="mdc-checkbox__checkmark-path"
                                fill="none"
                                d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
                        </svg>
                        <div class="mdc-checkbox__mixedmark"></div>
                        </div>
                    </div>
                    <label for="informationConsent" class="t-subtitle3">
                        {{$t('483')}}
                        <!-- 결제 정보에 동의합니다. -->
                    </label>
                </div>               

                <!-- <div class="t-body4 d-flex justify-content-end align-items-center"> -->
                    <div class="t-body4 d-flex align-items-center">
                    <a class="link" @click="showPaymentPolicy()">
                        {{$t('484')}}
                        <!-- 결제 및 환불정책 -->
                    </a>
                </div>
            </div>

            <div class="mgt-26">            
                <button class="mdc-button mdc-button--raised btn-red btn-big w-full" @click="callPayment()">
                    {{$t('485')}}
                    <!-- 결제하기 -->
                </button>
            </div>
        </div>

        <!-- 결제 데이터 전송 폼 Payment data transfer form -->
        <form method="POST" action="" ref="formPayment">
            <input name="authToken" type="hidden" :value="authToken">
            <input name="paymentMethod" type="hidden" :value="paymentMethod">
            <input name="returnUrl" type="hidden" :value="returnUrl">
            <input name="ordererEmail" type="hidden" :value="ordererEmail">
            <input name="ordererPhone" type="hidden" :value="ordererPhone">
            <input name="informationConsent" type="hidden" :value="informationConsent">
            <input name="depositorName" type="hidden" :value="depositorName">
            <input name="data[deposit_account_id]" type="hidden" :value="creditcardId">
        </form>
    </section>
</template>

<script>
/**
 * 구매하기 - 결제하기 컴포넌트(sales - Make payment component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import salesApi  from '@/api/salesApi.js'
import {mapState, mapMutations} from 'vuex'
import AddCreditCard from './AddCreditCard.vue'

export default {
    components: {
        'add-credit-card' : AddCreditCard
    },
    data() {
        return {
            authToken: '',    
            orderData: {},
            purchasedData: [],
            paymentText: '',
            paymentButtonText: '',

            orderId: '',
            paymentMethod: '',
            returnUrl: '',
            ordererEmail: '',
            ordererPhone: '',
            informationConsent: false,
            depositorName: '',
            deposit_account_id: '',
            creditcardList: [],
            isAddCardForm: false,
            creditcardId: '',

            paymentMethodList: [],


        }
    },
    mounted() {
        document.documentElement.style.overflow = 'auto'
        window.onscroll = null

        this.fetchData()
        this.fatchCreditCard()


        this.ordererEmail = this.sales.ordererEmail
        this.ordererPhone = this.sales.ordererPhone
        this.depositorName = this.sales.ordererName

        if (!this.ordererEmail || !this.ordererPhone || !this.depositorName) {
            this.$router.go(-1)
            return
        }

        const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
            let button = new MDCRipple.attachTo(el)
            return button
        })
    },

    computed: {
        ...mapState('sales',{
            sales : state => state,
        })
    },

    updated() {
        // 수동결제 일 경우 입금자명 머티리얼 적용(In case of manual payment, depositor name material is applied)
        if (this.paymentMethod === 'bank_transfer') {
            let depositorNameEl = new MDCTextField(document.getElementById('depositorNameEl'))
            depositorNameEl.useNativeValidation = false
        }
    },
    
    methods: {
        // 결제 데이터 생성 API 호출
        fetchData() {
            let responseData = ''
            let params = this.setParams()
            
            // get sales order infomation
            salesApi.salesGoodsOrder(params).then((response) => {
                this.orderData = response.data.data
                this.orderId = this.orderData.orderId
                this.returnUrl = process.env.VUE_APP_PAYMENT_RETURN_HOST + `/sales/resultpaypal/${this.orderId}`
                //this.returnUrl = `http://192.168.1.9:8080/sales/resultpaypal/${this.orderId}`
                this.authToken = localStorage.getItem('token')

                let headerTitle = this.$t('460') //결제 정보
                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'close',
                    rightBtnMode: '',
                    title: headerTitle,
                    leftBtnMethod: () => {
                        this.$router.go(-1)
                    },
                    rightBtnMethod: '',
                })
            }).catch((err) => {})

            // get payment method list
            salesApi.salesPaymentMethodList().then((response) => {
                console.log('salesPaymentMethodList', response.data.data);
                this.paymentMethodList = response.data.data
            }).catch((err) => {})

            
        },

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                goodsId: this.$route.params.goodsid
            }
            return params
        },

        // 결제 요청(request payment)
        callPayment() {
            if (this.informationConsent && this.paymentMethod) {

                if (this.paymentMethod === 'paypal') {
                    if (!this.creditcardId) {
                        this.$alert({
                            title: this.$t('50028'), //'TODO-페이팔 결제 유형 선택',
                            content: this.$t('50029'), //'TODO-계정 혹은 카드를 선택해주세요.',
                            accept:  this.$t('50030'), //'TODO-확인',
                        }).then(() => {
                            
                        })
                        return false
                    }

                    if (this.creditcardId === 'account') {
                        this.paymentMethod = 'paypal'
                    }else {
                        this.paymentMethod = 'credit_card'
                    }
                    let paymemtHost = process.env.VUE_APP_PAYMENT_HOST
                    this.$refs.formPayment.method = 'post'
                    this.$refs.formPayment.action = `${paymemtHost}/sales/order/${this.orderData.orderId}/pay`
                    // this.$refs.formPayment.action = `http://192.168.1.32:8090/sales/order/${this.orderData.orderId}/pay`
                    // console.log('결제창으로 ㄱㄱ~2', this.$refs.formPayment.method, this.$refs.formPayment.action)
                    this.$refs.formPayment.submit()
                }else if (this.paymentMethod === 'bank_transfer') {
                    if (!this.depositorName) {
                        this.$alert({
                            title: this.$t('50031'), //'TODO-정보입력 오류',
                            content: this.$t('50032'), //'TODO-입금자 이름을 입력해주세요.',
                            accept:  this.$t('50033'), //'TODO-확인',
                        }).then(() => {
                            
                        })
                        return false
                    }
                    
                    let params = {
                        orderId: this.orderId,
                        paymentMethod: this.paymentMethod,
                        returnUrl: '',
                        ordererEmail: this.ordererEmail,
                        ordererPhone: this.ordererPhone,
                        informationConsent: this.informationConsent,
                        depositorName: this.depositorName,
                        data: {
                            DEPOSIT_ACCOUNT_ID: ''
                        }
                    }

                    let responseData = null
                    salesApi.salesRequestPayment(params).then((response) => {
                        responseData = response.data.data
                        console.log('responseData', responseData);
                        // this.movePaymentResult()
                        this.moveResultBank()
                    }).catch((err) => {
                        // responseData = err.response.data.meta
                        // this.$error({content: responseData.errMsg}).then(() => {})
                    })
                }
                
            }else {
                if (this.paymentMethod === '') {
                    this.$alert({
                        content: this.$t('50034'), //'TODO-결제 수단을 선택해 주세요.',
                        accept:  this.$t('50035'), //'확인',
                    }).then(() => {
                        return
                    })
                }else if (!this.informationConsent) {
                    this.$alert({
                        content: this.$t('50036'), //'TODO-결제 정보 동의에 체크해 주세요.',
                        accept:  this.$t('50037'), //'확인',
                    }).then(() => {
                        return
                    })
                }
            }
            
            
        },

        // 결제수단 설정(set payment method)
        setPaymentMethod(method) {
            this.paymentMethod = method
        },

        // 수동결제 완료화면 이동(Manual payment completion screen move)
        moveResultBank() {
            this.$router.push({
                name: 'SalesResultBank', 
                params: {orderId: this.orderId}
            })
        },

        // 카드목록 토글(toggle card list)
        toggleAddCardForm() {
            this.isAddCardForm = !this.isAddCardForm
        },

        // 등록된 카드정보 조회 API 호출(get registed card list)
        fatchCreditCard() {
            salesApi.salesCreditcardList().then((response) => {
                this.creditcardList = response.data.data
            }).catch((err) => {
                
            })
        },

        // 카드 삭제 API 호출(delete card)
        deleteCreditCard(id) {
            this.$confirm({
                title: this.$t('877'), //등록된 카드 정보 삭제
                content: this.$t('878') +'<br>'+ this.$t('879'), //이 카드 정보를 삭제하시겠습니까? 확인을 누르면 카드 정보가 삭제됩니다.
                accept: this.$t('881'),
                cancel: this.$t('880')
            }).then(() => {
                let params = {
                    id: id
                }
                salesApi.salesCreditcardDelete(params).then((response) => {
                    console.log('salesCreditcardDelete', response.data.data);
                    this.fatchCreditCard()
                }).catch((err) => {})    
            }).catch((err) => {})
            
        },

        // 결제 정책 POPUP(Payment Policy POPUP)
        showPaymentPolicy() {
            let message = {
                title: this.$t('484'),
                contents: 'Todo-Contnets',
                //accept: '1'
            }
            this.$alert(message).then(() => {

            })
        }
    },
}
</script>